export default __webpack_public_path__ + "static/media/q29.33d7bc7c.png";